import type { CSSProperties } from 'react';

const SEMMY_IMAGE_URL = 'https://vtcltcyublsvhrrnxbsh.supabase.co/storage/v1/object/public/semmy-avatars/Semmy.jpg';

interface SemmyAvatarProps {
  size?:          number;
  thinking?:      boolean;
  style?:         CSSProperties;
  imageUrl?:      string | null;
  showOnlineDot?: boolean;
}

export function SemmyAvatar({
  size          = 28,
  thinking      = false,
  style,
  imageUrl,
  showOnlineDot = true,
}: SemmyAvatarProps) {
  return (
    // Outer wrapper — NO overflow:hidden so ring renders outside
    <div
      style={{
        position:   'relative',
        width:      size,
        height:     size,
        flexShrink: 0,
        ...style,
      }}
    >
      {/* Breathing ring — sits OUTSIDE overflow:hidden */}
      <div
        className={thinking ? 'avatar-ring-active' : ''}
        style={{
          position:      'absolute',
          inset:         -4,
          borderRadius:  '50%',
          border:        `1.5px solid ${thinking ? 'var(--accent)' : 'var(--border-hover)'}`,
          opacity:       thinking ? 0.9 : 0.30,
          transition:    'opacity 0.3s ease, border-color 0.3s ease',
          pointerEvents: 'none',
        }}
      />

      {/* Outer glow when thinking */}
      {thinking && (
        <div
          style={{
            position:      'absolute',
            inset:         -10,
            borderRadius:  '50%',
            background:    'radial-gradient(circle, rgba(124,158,248,0.18) 0%, transparent 70%)',
            animation:     'avatarRing 1.6s ease-in-out infinite',
            pointerEvents: 'none',
          }}
        />
      )}

      {/* Avatar core — overflow:hidden ONLY here for image clipping */}
      <div
        style={{
          width:          size,
          height:         size,
          borderRadius:   '50%',
          overflow:       'hidden',
          background:     'transparent',
          border:         `1.5px solid ${thinking ? 'var(--accent)' : 'var(--border-hover)'}`,
          display:        'flex',
          alignItems:     'center',
          justifyContent: 'center',
          fontSize:       size * 0.43,
          fontWeight:     '600',
          color:          'var(--accent)',
          transition:     'border-color 0.3s ease',
          ...(thinking ? { filter: 'drop-shadow(0 0 6px rgba(124,158,248,0.30))' } : {}),
        }}
      >
        <img
          src={imageUrl ?? SEMMY_IMAGE_URL}
          alt="Semmy"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </div>

      {/* Online dot — OUTSIDE overflow:hidden */}
      {showOnlineDot && (
        <div
          style={{
            position:     'absolute',
            bottom:       size > 32 ? 0 : -1,
            right:        size > 32 ? 0 : -1,
            width:        size > 32 ? 9 : 7,
            height:       size > 32 ? 9 : 7,
            borderRadius: '50%',
            background:   'var(--accent)',
            border:       '2px solid var(--bg-surface)',
            zIndex:       10,
          }}
        />
      )}
    </div>
  );
}
